import '@babel/polyfill'

import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

import VScrollLock from "v-scroll-lock";

import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { TextPlugin } from "gsap/TextPlugin";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import panZoom from 'vue-panzoom'


gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(TextPlugin);
gsap.registerPlugin(ScrollToPlugin);

Vue.config.productionTip = false;

Vue.use(VScrollLock);
Vue.use(panZoom);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
